import { Injectable } from '@angular/core';
import { ApplicationLocale } from '../../common/model';
import { Brands } from '../enums';
import { BV_CONFIG } from './baazarvoice/displayCode.config';

@Injectable()
export class BaazarvoiceService {

  constructor() {}

  public getBVoiceValue(hotelBrand: Brands, countryLanguage: ApplicationLocale): string {
    let bvDefaultEntryValue: string = '';
    let bvDefaultHotelBrandValue: string = '';
    let bvCountryLanguageValue: string = '';

    BV_CONFIG.forEach(function (bvHotelEntry) {
      if (bvHotelEntry.id === hotelBrand) {
        bvHotelEntry.entry.forEach(function (bvCountryLanguageEntry) {
          if (bvCountryLanguageEntry.key === countryLanguage) {
            bvCountryLanguageValue = bvCountryLanguageEntry.value;
          }
          // If the hotel does not support a language this has to return en_us value as default
          if (bvCountryLanguageEntry.key === ApplicationLocale.en_US) {
            bvDefaultEntryValue = bvCountryLanguageEntry.value;
          }
        });
      }
      if (bvHotelEntry.id === Brands.IHG) {
        bvHotelEntry.entry.forEach(function (bvCountryLanguageEntry) {
          if (bvCountryLanguageEntry.key === ApplicationLocale.en_US) {
            bvDefaultHotelBrandValue = bvCountryLanguageEntry.value;
          }
        });
      }
    });

    // return the value if the brand and language are supported if the brand is not supported return the en_us value for the IHG brand
    return bvCountryLanguageValue ? bvCountryLanguageValue : (bvDefaultEntryValue ? bvDefaultEntryValue : bvDefaultHotelBrandValue);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/baazarvoice.service.ts